// Lib
import { FC, useEffect, useState } from "react";
// Api
import { useUpdateUserMutation } from "rtkQuery/query/usersAPI";
// Hooks
import { useNotification, useViewport } from "hooks";
// Actions
// Selectors
// Types
// Theme
// Constants
// Helpers
// Utils
import { errorHandler } from "utils/errorHandler";
// Icons
// Layouts
// Components
import { Switch } from "components/Form";
// Styled
import { FlexContainer } from "styled/Box";
import { Typography } from "styled/Typography";

interface AIAssistantEnabledProps {
  id: string;
  isLoading: boolean;
  isAIAssistantEnabled: boolean | undefined;
}

export const AIAssistantEnabled: FC<AIAssistantEnabledProps> = ({
  id,
  isLoading,
  isAIAssistantEnabled,
}) => {
  const { openNotification } = useNotification();

  const { isMobile } = useViewport();

  const [update, { isLoading: isUpdateLoading }] = useUpdateUserMutation();

  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    if (typeof isAIAssistantEnabled === "boolean") {
      setIsChecked(isAIAssistantEnabled);
    }
  }, [isAIAssistantEnabled]);

  const handleStatusChange = async (value: boolean) => {
    try {
      setIsChecked(value);

      await update({ id, isAIAssistantEnabled: value }).unwrap();
    } catch (error) {
      errorHandler({ error, openNotification });
      setIsChecked(!value);
    }
  };

  return (
    <FlexContainer
      $align={isMobile ? "flex-end" : "center"}
      $fullwidth={isMobile}
      $justify={isMobile ? "flex-end" : "center"}
      $gap={10}
    >
      <Typography.Title>AI Features</Typography.Title>
      <Switch
        loading={isLoading || isUpdateLoading}
        checked={isChecked}
        onChange={value => handleStatusChange(value)}
      />
    </FlexContainer>
  );
};
